<template lang="pug">
  .page
    .hamburger-menu.d-lg-none(@click="openmenu" :class="open?'open':''")
        span
        span
        span
        span
    slot(name="menu")
    .content
      .container
        slot
      footer.footer.footer-transparent
        .container
          .row.text-center.align-items-center.flex-row-reverse
            .col-lg-auto.ml-lg-auto
              | Powered by Kerala Startup Mission &#xae;
            .col-12.col-lg-auto.mt-3.mt-lg-0
              | Copyright &copy; 2020 All rights reserved.

</template>

<script>
import { mapState, mapActions } from 'vuex';


export default {
  data(){
    return{
      
    }
  },
  computed: {
    ...mapState('menu', ['open'])
  },
  methods: {
    openmenu(){
      this.toggle_menu();
    },
    ...mapActions('menu',['toggle_menu'])
  },
}
</script>

<style lang="scss" scoped>
.hamburger-menu {
  position: relative;
  right: 20px;
  width: 100%;
  max-width: 24px;
  height: 22px;
  margin-left: auto;
  transition: .5s ease-in-out;
  margin-top: 10px;
  cursor: pointer;
  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #ea0763;
    border-radius: 10px;
    opacity: 1;
    left: 0;
    transition: .25s ease-in-out;
    &:nth-child(1) {
      top: 2px;
    }
    &:nth-child(2),
    &:nth-child(3) {
      top: 10px;
    }
    &:nth-child(4) {
      top: 18px;
    }
  }
  &.open span {
    &:nth-child(1) {
      top: 18px;
      width: 0;
      left: 50%;
    }
    &:nth-child(2) {
      transform: rotate(45deg);
    }
    &:nth-child(3) {
      transform: rotate(-45deg);
    }
    &:nth-child(4) {
      top: 18px;
      width: 0;
      left: 50%;
    }
  }
}
</style>

